"use client";

import { useEffect, useRef } from "react";
import AppImage from "@/components/ui/AppImage";

const equipment = [
  {
    name: "Reformer",
    description: "O equipamento mais versátil do Pilates. Permite centenas de exercícios para todo o corpo com resistência ajustável.",
    image: "https://img.rocket.new/generatedImages/rocket_gen_img_17189d01c-1772741695226.png",
    alt: "Reformer de Pilates moderno com molas de resistência e carrinho deslizante"
  },
  {
    name: "Cadillac",
    description: "Ideal para reabilitação e exercícios avançados. Oferece suporte completo e variedade de movimentos.",
    image: "https://img.rocket.new/generatedImages/rocket_gen_img_151850b8a-1772741695472.png",
    alt: "Cadillac de Pilates com barra de trapézio e molas laterais para exercícios completos"
  },
  {
    name: "Chair & Acessórios",
    description: "Wunda Chair, rolos, bolas e faixas elásticas para complementar e enriquecer cada sessão.",
    image: "https://img.rocket.new/generatedImages/rocket_gen_img_11e348de4-1772741694818.png",
    alt: "Acessórios de Pilates incluindo Wunda Chair, rolos de espuma e faixas elásticas"
  }
];

export default function EquipmentSection() {
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((e) => {
          if (e.isIntersecting) {
            e.target.classList.remove("reveal-hidden");
            e.target.classList.add("reveal-active");
          }
        });
      },
      { threshold: 0.08 }
    );
    ref?.current?.querySelectorAll(".reveal-hidden")?.forEach((el) => observer?.observe(el));
    return () => observer?.disconnect();
  }, []);

  return (
    <section className="py-32 md:py-44 px-6 md:px-10 bg-cream" ref={ref}>
      <div className="max-w-8xl mx-auto">
        <div className="text-center mb-20">
          <span className="reveal-hidden subheading mb-5 block">Infraestrutura</span>
          <h2 className="reveal-hidden reveal-delay-1 font-serif text-forest leading-tight"
            style={{ fontSize: 'clamp(2.2rem, 5vw, 3.5rem)' }}>
            Equipamentos de{" "}
            <span className="italic font-light text-sage">alta qualidade</span>
          </h2>
          <p className="reveal-hidden reveal-delay-2 mt-5 max-w-xl mx-auto" style={{ color: 'var(--stone)', fontSize: '1.05rem' }}>
            Investimos nos melhores equipamentos para garantir segurança, eficiência e resultados excepcionais.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-10">
          {equipment?.map((item, i) => (
            <div key={item?.name} className={`reveal-hidden reveal-delay-${i + 1} group`}>
              <div className="gallery-item rounded-4xl overflow-hidden aspect-[4/3] mb-8"
                style={{ boxShadow: '0 8px 40px rgba(26,61,26,0.1)' }}>
                <AppImage
                  src={item?.image}
                  alt={item?.alt}
                  fill
                  className="object-cover w-full h-full"
                />
              </div>
              <h3 className="font-serif mb-3" style={{ fontSize: '1.6rem', color: 'var(--forest)' }}>{item?.name}</h3>
              <p className="text-sm leading-relaxed" style={{ color: 'var(--stone)' }}>{item?.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}